import { apiUrl } from '@configs/environment';
import axios from 'axios';
import { httpInterceptorsRequestUse, httpInterceptorsResponseUse, paramsSerializer } from '@shared/helpers/httpHelpers';

const httpClient = axios.create({
  baseURL: apiUrl,
  headers: { Accept: 'Application/Json' },
  paramsSerializer,
});

httpInterceptorsRequestUse(httpClient);

httpInterceptorsResponseUse(httpClient);

export default httpClient;
